import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse, IGenericPagination } from "src/types/generic";
import apiFastifyClient from "./apiFastifyCloud";
import { IDeliveryDriver } from "src/types/delivery";

interface IParams {
  page?: number;
  limit?: number;
  status?: "active" | "archived";
  search?: string;
  locationId?: string;
}

interface IDeliveryDriversResponse {
  data: IDeliveryDriver[];
  meta: IGenericPagination;
}

export const useGetDeliveryDriversList = (params: IParams) =>
  useQuery<void, APIErrorResponse, IDeliveryDriversResponse>({
    queryKey: [params],
    queryFn: async () => {
      return apiFastifyClient.get(`/v1/deliveries`, { params });
    },
    gcTime: 30 * 60 * 1000,
  });

export const useAddDriverMutation = () =>
  useMutation<any, APIErrorResponse, any>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(`/v1/deliveries`, data);
    },
  });

export const useUpdateDriverMutation = () =>
  useMutation<any, APIErrorResponse, any>({
    mutationFn: async (data) => {
      const { id, ...rest } = data;
      return apiFastifyClient.patch(`/v1/deliveries/${id}`, rest);
    },
  });

export const useGetDriverById = ({ id }: { id: string }) =>
  useQuery<any, APIErrorResponse, { data: IDeliveryDriver }>({
    queryKey: ["get-driver-by-id"],
    queryFn: async () => {
      return apiFastifyClient.get(`/v1/deliveries/${id}`);
    },
    gcTime: 0,
    enabled: !!id,
  });

export const useArchiveDriverMutation = () =>
  useMutation<any, APIErrorResponse, { id: string }>({
    mutationFn: async ({ id }) => {
      return apiFastifyClient.put(`/v1/deliveries/${id}/archive`);
    },
  });

export const useActivateDriverMutation = () =>
  useMutation<any, APIErrorResponse, { id: string }>({
    mutationFn: async ({ id }) => {
      return apiFastifyClient.put(`/v1/deliveries/${id}/activate`);
    },
  });
